/**
 * Returns the shared QR dialog element, creating it on first call.
 * Using a single element shared across all QR features on the page.
 *
 * @return {HTMLDialogElement} The dialog element.
 */
function getDialog() {
	const existing = document.querySelector( '.qala-qr-codes__qr-dialog' );

	if ( existing ) {
		return existing;
	}

	const dialog = document.createElement( 'dialog' );
	dialog.className = 'qala-qr-codes__qr-dialog';

	const closeBtn = document.createElement( 'button' );
	closeBtn.className = 'qala-qr-codes__qr-dialog-close';
	closeBtn.setAttribute( 'aria-label', 'Close' );
	closeBtn.textContent = '\u00D7';
	closeBtn.addEventListener( 'click', () => dialog.close() );

	const dialogImg = document.createElement( 'img' );
	dialogImg.className = 'qala-qr-codes__qr-dialog-image';
	dialogImg.alt = '';

	dialog.appendChild( closeBtn );
	dialog.appendChild( dialogImg );
	document.body.appendChild( dialog );

	dialog.addEventListener( 'click', e => {
		if ( e.target === dialog ) {
			dialog.close();
		}
	} );

	return dialog;
}

/**
 * Open the shared QR dialog with the given image src.
 *
 * @param {string} src Image src to display.
 */
export function openQRDialog( src ) {
	const dialog = getDialog();
	dialog.querySelector( '.qala-qr-codes__qr-dialog-image' ).src = src;
	dialog.showModal();
}
